const bpayGetter = (state) => state.bpay;

export const bpaySelector = (state) => ({
  bpay: bpayGetter(state)
});
